module.exports = __webpack_public_path__ + "media/images/indicators/ndvi-052b8a613aa0464733b808afaacc1679.png";